<script setup>
import {defineModel, defineProps} from 'vue'


const transactionsList = defineModel('transactionsList')
const transactionsQuantity = defineModel('transactionsQuantity')


const props = defineProps({
    price: {
        type: Number,
        required: true
    },
    pricePerTransaction: {
        type: Number,
        required: true
    }
})





function formatValue(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

function selectTransaction(transaction) {
    transactionsQuantity.value = transaction
}

</script>

<template>
    <div class="w-full flex flex-col items-center justify-center">
        <!-- Выбрать тариф -->
        <div class="w-full bg-white p-4 lg:p-[25px] border border-[#e1e1e1] rounded-[16px]">
            <div class="font-bold text-[18px] lg:text-[20px] mb-4 lg:mb-[32px]">Купить дополнительные транзакцции</div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-[16px] w-full">
                <div
                    class="flex flex-col justify-center p-3 lg:p-[18px] border-2 gap-2 w-full rounded-[16px] relative cursor-pointer duration-200 transition-all"
                    :class="{
                    'bg-blue-50 border-blue-500': tran === transactionsQuantity,
                    'border-[#e1e1e1] hover:border-blue-300 hover:bg-[#eff8ff]': tran !== transactionsQuantity,
                }"
                    @click="selectTransaction(tran)"
                    v-for="tran in transactionsList" v-bind:key="tran"
                >
                    <div class="flex items-center gap-2 font-bold text-[14px]">
                        {{ formatValue(tran) }} транзакций
                    </div>
                    <div class="flex items-center gap-2 font-bold text-[16px]">
                        {{ formatValue(tran * props.pricePerTransaction) }} ₽
                    </div>
                    <div class="flex items-center gap-2">
                        {{ props.pricePerTransaction }} ₽/транзакция
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>